/**
 * Grammar authoring types.
 *
 * A grammar is a small state machine. Each state describes only the patterns
 * that are *interesting* in that state; anything the state does not match is
 * emitted with the state's `default` scope. That is what keeps grammars short:
 * a string state needs three rules (escape, interpolation, closing quote), not
 * a rule for "string content".
 */
/**
 * The placeholder a pattern uses to match the remembered text again. The text
 * is inserted escaped, so it matches literally.
 */
export const REMEMBERED = '{{remembered}}';
